import React from 'react';
import { Route, Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import {DashboardLayout} from './DashboardLayout';
import { DomikLoading } from '../common/DomikLoading';

type DashboardLayoutRouteProps = {
    component: any;
    path?: string;
    exact?: boolean;
}

export const DashboardLayoutRoute = (props: DashboardLayoutRouteProps) => {

    const { component: Component, ...rest } = props;

    const userInfo = useSelector((state: any) => state.userInfo);

    return (<Route
        {...rest}
        render={props => {

            if (!userInfo.Loaded) {
                return <div style={{ textAlign: 'center', marginTop: '50px' }}><DomikLoading /></div>;
            }

            if (userInfo.Anonymous) {
                return <Redirect to="/login" />;
            }

            return (
                <DashboardLayout>
                    <Component {...props} />
                </DashboardLayout>
            );
        }} />
    )
};

